export default {
  accessTable: null,
  rolesEmployees: [],
  roles: [],
}
